var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { deserializeSnapshot, recursivelySerialize } from "./Serializers";
export class SerializingFirebaseWrapper {
    constructor(firebase) {
        this.firebase = firebase;
    }
    onValue(path, callback) {
        return this.firebase.onValue(path, (snapshot) => callback(deserializeSnapshot(snapshot)));
    }
    onChildAdded(path, callback) {
        return this.firebase.onChildAdded(path, (snapshot, previousChildName) => callback(deserializeSnapshot(snapshot), previousChildName));
    }
    onChildChanged(path, callback) {
        return this.firebase.onChildChanged(path, (snapshot, previousChildName) => callback(deserializeSnapshot(snapshot), previousChildName));
    }
    onChildRemoved(path, callback) {
        return this.firebase.onChildRemoved(path, (snapshot) => callback(deserializeSnapshot(snapshot)));
    }
    set(path, value) {
        return this.firebase.set(path, recursivelySerialize(value));
    }
    get(path) {
        return __awaiter(this, void 0, void 0, function* () {
            return deserializeSnapshot(yield this.firebase.get(path));
        });
    }
    onDisconnect(path) {
        return this.firebase.onDisconnect(path);
    }
    remove(path) {
        return this.firebase.remove(path);
    }
    runTransaction(path, transactionUpdate, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const transactionResult = yield this.firebase.runTransaction(path, (currentData) => { return recursivelySerialize(transactionUpdate(currentData)); }, options);
            return Object.assign(Object.assign({}, transactionResult), { snapshot: deserializeSnapshot(transactionResult.snapshot) });
        });
    }
    update(path, values) {
        return this.firebase.update(path, recursivelySerialize(values));
    }
}
//# sourceMappingURL=SerializingFirebaseWrapper.js.map